export default "__VITE_ASSET__C_oL7rgG__"